/* eslint-disable no-unused-vars */
import {CheckBox, Layout} from '@ui-kitten/components';
import React, {useCallback, useEffect, useState} from 'react';
import {StyleSheet} from 'react-native';
import {px} from '../../utils';
import TitleRow from './TitleRow';

const CheckboxList = ({
  title,
  list,
  selectedItems,
  setSelectedItems,
  containerStyle,
}) => {
  const [allChecked, setAllChecked] = useState(false);
  const [indeterminate, setIndeterminate] = useState(false);
  const [isListVisible, setIsListVisible] = useState(true);

  const updateAllCheckedStatus = useCallback(() => {
    const someChecked =
      list?.length &&
      list?.some((listItem) =>
        selectedItems.some(
          (selectedItem) => listItem.value === selectedItem.value,
        ),
      );
    const everyChecked =
      list?.length &&
      list?.every((listItem) =>
        selectedItems.some(
          (selectedItem) => listItem.value === selectedItem.value,
        ),
      );

    if (someChecked && !everyChecked) {
      setAllChecked(true);
      setIndeterminate(true);
    } else if (!someChecked && !everyChecked) {
      setAllChecked(false);
      setIndeterminate(false);
    } else if (everyChecked) {
      setAllChecked(true);
      setIndeterminate(false);
    }
  }, [list, selectedItems]);

  useEffect(() => {
    updateAllCheckedStatus();
  }, [updateAllCheckedStatus]);

  // const onAllBoxChange = (nextChecked) => {
  //   if (nextChecked) {
  //     setAllChecked(true);
  //     setSelectedItems(list);
  //   } else {
  //     setAllChecked(false);
  //     setSelectedItems([]);
  //   }
  // };

  const renderRow = (row) => {
    const checked = selectedItems.some(
      (selectedItem) => selectedItem.value === row.value,
    );

    const onChange = (nextChecked) => {
      if (nextChecked) {
        // var isSameSubjectSelected = false;
        // if (row.name) {
        //   var isSameSubjectSelected = selectedItems.some(
        //     (item) => item.name === row.name,
        //   );
        // }
        // if (isSameSubjectSelected) {
        //   var filteredItem = selectedItems.filter(
        //     (item) => item.name !== row.name,
        //   );
        //   setSelectedItems([...filteredItem, row]);
        // } else {
        //   setSelectedItems([...selectedItems, row]);
        // }

        setSelectedItems([...selectedItems, row]);
      } else {
        setSelectedItems(
          selectedItems.filter(
            (selectedItem) => selectedItem.value !== row.value,
          ),
        );
      }
    };

    return (
      <CheckBox
        key={row.value}
        checked={checked}
        onChange={onChange}
        style={styles.row}>
        {row.text}
      </CheckBox>
    );
  };

  return (
    <Layout style={containerStyle}>
      <TitleRow
        title={title}
        type="secondary"
        iconName={
          isListVisible
            ? 'arrow-ios-upward-outline'
            : 'arrow-ios-downward-outline'
        }
        onIconClick={() => setIsListVisible(!isListVisible)}
        containerStyle={styles.title}
      />
      {list?.length && isListVisible && (
        <Layout level="1">
          {/* <CheckBox
            key="all"
            checked={allChecked}
            indeterminate={indeterminate}
            onChange={onAllBoxChange}
            style={styles.row}>
            {'All'}
          </CheckBox> */}
          {list?.map(renderRow)}
        </Layout>
      )}
    </Layout>
  );
};

const styles = StyleSheet.create({
  row: {
    marginVertical: px(12),
    marginHorizontal: px(17),
  },
});

export default CheckboxList;
